module.exports = __webpack_public_path__ + "img/icon_2_21.88f3dd2d.png";